import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Overview from './pages/overview'
import Events from './pages/events';
import Bookings from './pages/bookings';
import Users from './pages/users';
import Schedule from './pages/schedule';
import Content from './pages/content';
import Reviews from './pages/reviews';
import Login from './pages/login';
import AccessDenied from './pages/accessdenied';
import ErrorPage from './pages/error';


const Paths = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/events" element={<Events/>} />
        <Route path="/bookings" element={<Bookings/>} />
        <Route path="/users" element={<Users/>} />
         <Route path="/schedule" element={<Schedule/>} />
         <Route path="/content" element={<Content/>} />
         <Route path="/reviews" element={<Reviews/>} />
         <Route path="/login" element={<Login/>} />
         <Route path="/access-denied" element={<AccessDenied/>} />
         <Route path="*" element={<ErrorPage/>} />
      </Routes>
    </BrowserRouter>
  );
};

export default Paths;